import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _UpdateSubscriptionRequestDtoSchema = z.object({
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
  facilityId: z.number(),
  isEnabled: z.boolean(),
});

const UpdateSubscriptionsResponseDtoSchema = z.object({
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
  facilityId: z.number(),
  isEnabled: z.boolean(),
});

export type UpdateSubscriptionRequestDto = z.infer<
  typeof _UpdateSubscriptionRequestDtoSchema
>;
export type UpdateSubscriptionsResponseDto = z.infer<
  typeof UpdateSubscriptionsResponseDtoSchema
>;

export const updateSubscription = (
  params: UpdateSubscriptionRequestDto,
  config?: AxiosRequestConfig<UpdateSubscriptionRequestDto>
) => {
  return api
    .patch('market-intel-subscription', params, config)
    .then(responseContract(UpdateSubscriptionsResponseDtoSchema));
};
